const MANAGER_STATES = {
    CREATE: "FORM",
    LIST: "LIST",
};
export default MANAGER_STATES;
